module.exports = __webpack_public_path__ + "static/gallery-3@2x-fd6fb56587ec8b2a0490bff7c0eab2d8.jpg";